import ChangePasswordSubview from './subviews/change-password';
import ConsentSubview from './subviews/consent';
import PersonalDetailsSubview from './subviews/personal-details';
import PreferredDealerSubview from './subviews/preferred-dealer';

export default class PersonalDetailsView {
    constructor(parent) {
        this.parent = parent;
        this.router = parent.router;
        this.el = parent.el.querySelector('.personal-details-view');
        this.subviews = {
            'change-password': new ChangePasswordSubview(this),
            consent: new ConsentSubview(this),
            'personal-details': new PersonalDetailsSubview(this),
            'preferred-dealer': new PreferredDealerSubview(this),
        };
    }

    show() {
        this.el.classList.remove('hide');
        this.scroll();
    }

    hide() {
        this.el.classList.add('hide');
    }

    scroll() {
        const section = this.router.params.get('section');
        this.subviews[section]?.el?.scrollIntoView({ behavior: 'smooth' });
    }
}
